
const filters = {
  /**
  * 格式化千位符,钱的格式,
  * @num  10000
  * return  1,000
  * **/
  formatMoney (num) {
    num = filters.formatNumber(num)
    if (isNaN(num)) {
      return ''
    }
    if (!/^(\+|-)?(\d+)(,\d{3})*(\.|\.\d+)?$/.test(num)) {
      return num
    }
    let re = /(\d)(\d{3})(,|$)/, a = RegExp.$1, b = RegExp.$2, c = RegExp.$4
    while (re.test(b)) {
      b = b.replace(re, '$1,$2$3')
    }
    let value = a + '' + b + '' + c
    return value
  },
  /**
  * 还原number 类型,
  * @strval  1,000
  * return 1000
  * **/
  formatNumber (str) {
    str += ''
    if (str.indexOf(',') === -1) {
      return str
    }
    return str.replace(/,/g, '')
  },
  /***
  * 格式化数字类型,保留2位小数
  * @x  100
  * return 100.00
  * **/
  toDecimal2 (x) {
    if (!x) {
      return ''
    }
    let s = x.toString()
    let rs = s.split('.')
    let left = rs[0]
    let right = rs[1]
    if (right) {
      if (right.length > 2) {
        right = right.substring(0, 2)
      } else if (right.length < 2) {
        right += 0
      }
    } else {
      right = '00'
    }
    return left + '.' + right
  },
  // 小数位保留函数
  //*   num保留的数字，字符串都可以
  //*   digit 保留的位数
  formatNum (num, fix) {
    // num为原数字，fix是保留的小数位数
    let result = '0'
    if (Number(num) && fix > 0) { // 简单的做个判断
      fix = +fix || 2
      num = num + ''
      if (/e/.test(num)) { // 如果是包含e字符的数字直接返回
        result = num
      } else if (!/\./.test(num)) { // 如果没有小数点
        result = num + `.${Array(fix + 1).join('0')}`
      } else { // 如果有小数点
        result = Number(num).toFixed(fix)
      }
    }
    return result
  },
  /*
        去掉double类型小数点后面多余的0
        参数：old 要处理的字符串或double
        返回值：newStr 没有多余零的小数或字符串
        例： cutZero(123.000) -> 123
            cutZero(123.0001) -> 123.0001
            cutZero(10203000.0101000) -> 10203000.0101
            cutZero(10203000) -> 10203000
    */
  formatcutZero (old) {
    // 拷贝一份 返回去掉零的新串
    let newstr = old
    // 循环变量 小数部分长度
    var leng = old.length - old.indexOf('.') - 1
    // 判断是否有效数
    if (old.indexOf('.') > -1) {
      // 循环小数部分
      for (var i = leng; i > 0; i--) {
        // 如果newstr末尾有0
        if (newstr.lastIndexOf('0') > -1 && newstr.substr(newstr.length - 1, 1) === 0) {
          var k = newstr.lastIndexOf('0')
          // 如果小数点后只有一个0 去掉小数点
          if (newstr.charAt(k - 1) === '.') {
            return newstr.substring(0, k - 1)
          } else {
            // 否则 去掉一个0
            newstr = newstr.substring(0, k)
          }
        } else {
          // 如果末尾没有0
          return newstr
        }
      }
    }
    return old
  },
  // 税率显示两位小数去尾 0
  roundingRate (cur) {
    let temp = Number(cur).toFixed(2)
    let i = 1
    while (temp.charAt(temp.length - 1) === '0' && i <= 2) {
      if (i === 2) {
        temp = temp.substring(0, temp.length - 2)
      } else {
        temp = temp.substring(0, temp.length - 1)
      }
      i++
    }
    return isNaN(temp) ? 0 : Number(temp)
  },
  // 格式化状态值(例如是否启用状态1,0转为文字是或否)
  isStatus (value) {
    if (value || value === 0) {
      return value ? '是' : '否'
    } else {
      return ''
    }
  },

  //获取未来时间的剩余天数
  appointedDay(dateTime) {
    if (!dateTime) return "";
    // 指定日期和时间
    const EndTime = new Date(dateTime);
    // 当前系统时间
    const NowTime = new Date();
    const t = EndTime.getTime() - NowTime.getTime();
    const d = Math.floor(t / 1000 / 60 / 60 / 24);
    // const h = Math.floor(t / 1000 / 60 / 60 % 24);
    // const m = Math.floor(t / 1000 / 60 % 60);
    // const s = Math.floor(t / 1000 % 60);
    const html = "（" + (d+1) + " 天）";
    if (d < 0) {
      return "";
    } else {
      return html;
    }
  },

  // 格式化时间——MM-dd
  formatShowDate (val) {
    let date = new Date(val)
    return ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2)
  },
}

export default {
  filters
}



// WEBPACK FOOTER //
// ./src/utils/utils.js